// extracted by mini-css-extract-plugin
module.exports = {"ox33weu":"ox33weu"};